import React from 'react';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { grey } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: '#ffffff',
        height:50,
        width: 4,
        borderTopRightRadius: 2,
        borderBottomRightRadius: 2,
        transition: '0.2s',
        opacity: 0.4
    },
    hide: {
        opacity: 0
    }
}));

const MenuSelectedBorder = ({ opening }: any) => {
    const classes = useStyles();

    const className = opening ? classes.container : classNames(classes.container, classes.hide);
    return (
        <div className={className} />
    );
}

export default MenuSelectedBorder;
